import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { SharedComponent } from './components/shared/shared.component';
import { SidebarComponent } from './components/shared/sidebar/sidebar.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { LoginComponent } from './pages/login/login.component';
import { BreadcrumbsComponent } from './components/shared/breadcrumbs/breadcrumbs.component';

import { PrincipalComponent } from './pages/principal/principal.component';
import { DetalleEstudioComponent } from './pages/detalle-estudio/detalle-estudio.component';
import { TabDatosProyectoComponent } from './components/estudio/tab-datos-proyecto/tab-datos-proyecto.component';
import { TabDescargarComponent } from './components/estudio/tab-descargar/tab-descargar.component';
import { TabDocumentosEmitidosComponent } from './components/estudio/tab-documentos-emitidos/tab-documentos-emitidos.component';
import { TabParticipacionCiudadanaComponent } from './components/estudio/tab-participacion-ciudadana/tab-participacion-ciudadana.component';
import { SeguimientoComponent } from './pages/estudio/seguimiento/seguimiento.component';
import { DescripcionProyectoComponent } from './pages/estudio/descripcion-proyecto/descripcion-proyecto.component';
import { AreasEfectivasComponent } from './pages/estudio/areas-efectivas/areas-efectivas.component';
import { LineaBaseComponent } from './pages/estudio/linea-base/linea-base.component';
import { ParticipacionCiudadanaComponent } from './pages/estudio/participacion-ciudadana/participacion-ciudadana.component';
import { ImpactoAmbientalComponent } from './pages/estudio/impacto-ambiental/impacto-ambiental.component';
import { ManejoAmbientalComponent } from './pages/estudio/manejo-ambiental/manejo-ambiental.component';
import { ValoracionEconomicaComponent } from './pages/estudio/valoracion-economica/valoracion-economica.component';
import { MapaComponent } from './pages/estudio/mapa/mapa.component';
import { DatosGeneralesComponent } from './pages/estudio/datos-generales/datos-generales.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from "@angular/common/http";
import { StorageModule } from '@ngx-pwa/local-storage';
import { AreaEfectivaComponent } from './components/area-efectiva/area-efectiva.component';
import { TablaComponent } from './components/tabla/tabla.component';
import { CodigoTupaPipe } from './pipes/codigo-tupa.pipe';
import { DatepicketLocalizationService, I18n } from './services/datepicker.language.service';
import { MomentDateFormatter } from './services/dateformat.service';
import { NumericDirective } from './lib/numeric.directive';
import { UrlExternaComponent } from './pages/url-externa/url-externa.component';


@NgModule({
  declarations: [
    AppComponent,
    // SharedComponent,
    SidebarComponent,
    HeaderComponent,
    DatosGeneralesComponent,
    FooterComponent,
    LoginComponent,
    BreadcrumbsComponent,
    SeguimientoComponent,
    DescripcionProyectoComponent,
    PrincipalComponent,
    DetalleEstudioComponent,
    TabDatosProyectoComponent,
    TabDescargarComponent,
    TabDocumentosEmitidosComponent,
    TabParticipacionCiudadanaComponent,
    AreasEfectivasComponent,
    LineaBaseComponent,
    ParticipacionCiudadanaComponent,
    ImpactoAmbientalComponent,
    ManejoAmbientalComponent,
    ValoracionEconomicaComponent,
    MapaComponent,
    AreaEfectivaComponent,
    TablaComponent,
    CodigoTupaPipe,
    NumericDirective,
    UrlExternaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    NgbModule,
    StorageModule.forRoot({ IDBNoWrap: true })

  ],
  providers: [
    CodigoTupaPipe,
    I18n,
    { provide: NgbDatepickerI18n, useClass: DatepicketLocalizationService },
    { provide: NgbDateParserFormatter, useClass: MomentDateFormatter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
